<template>
    <div class="artist">
        <div class="row" v-if="artist">

            <ArtistProfileMedia/>


            <div class="col-lg-7">
                <div class="artist__content">
                    <div class="artist__booking mb-5">
                        <a href="" class="action"><i class="fa-solid fa-file-pdf"></i></a>
                        <a href="" class="action"><i class="fa-solid fa-print"></i></a>
                        <a :href="`/client/artist/${artist.id}/book`" class="btn btn_golden"><span>book now</span></a>
                    </div>
                    <div class="artist__info">
                        <dl>
                            <dt>
                                <svg width="24" height="24" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-microphone"></use>
                                </svg>
                                <span>Act Type: </span>
                            </dt>
                            <dd
                                v-for="(category, index) in combinedCategories"
                                :key="index"
                            >
                                {{ category }},
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                <svg width="24" height="24" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-play1"></use>
                                </svg>
                                <span>Duration in Minutes:  </span>
                            </dt>
                            <dd>
                                {{ artist.minutes_in_material }}
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                <svg width="24" height="24" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-cinema"></use>
                                </svg>
                                <span>Available Breakdown:  </span>
                            </dt>
                            <dd>
                                {{ artist.available_shows }}
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                <svg width="24" height="24" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-lang"></use>
                                </svg>
                                <span>Languages: </span>
                            </dt>
                            <dd
                                v-for="lang in artist.user_languages"
                                :key="lang"
                            >
                                {{ getLangName(lang) }},
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                <svg width="24" height="24" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-aeroport"></use>
                                </svg>
                                <span>Home Location / Airport:  </span>
                            </dt>
                            <dd>
                                {{ artist.airport }}
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                <svg width="24" height="24" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-region"></use>
                                </svg>
                                <span>Global Region:  </span>
                            </dt>
                            <dd
                                v-for="region in artist.global_region"
                                :key="region"
                            >
                                {{ getRegionName(region) }}
                            </dd>
                        </dl>
                    </div>

                    <div class="artist__testimonials mb-2" v-if="artist.shows?.quotes.length > 0">
                        <h2 class="artist__ttl">testimonials</h2>
                        <div class="item">
                            <div class="artist__quote" v-if="artist.shows?.quotes[0]" >
                                <p>{{ artist.shows?.quotes[0].quote_description }}</p>
                                <span class="author">{{ artist.shows?.quotes[0].author_name }}</span>
                                <span class="position">{{artist.shows?.quotes[0].quote_resource}}</span>
                            </div>
                        </div>
                        <div class="item">
                            <div class="artist__quote" v-if="artist.shows?.quotes[1]">
                                <p>{{ artist.shows?.quotes[1].quote_description }}</p>
                                <span class="author">{{ artist.shows?.quotes[1].author_name }}</span>
                                <span class="position"> {{ artist.shows?.quotes[1].quote_resource }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="text-right mb-5">
                        <a
                            :href="`/client/artist/${artist.id}/testimonials`"
                            class="btn btn_primary-outline"
                            v-if="artist.shows?.quotes.length > 1"
                        >
                            View All
                        </a>
                    </div>
                    <h2 class="artist__ttl" v-if="artist.bio">Biography</h2>
                    <p>{{ artist.bio }}</p>
                    <h2 class="artist__ttl" v-if="artist.file_rider" >Artist rider</h2>
                    <p
                        v-if="artist.file_rider"
                    ><b><a
                        :href="`/uploads/${artist.file_rider.file_path}`"
                        class="text-underline"
                        download

                        target="_blank"
                    >link to download a rider in PDF or some promo materials</a></b>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ArtistProfileMedia from "../Common/ArtistProfileMedia.vue";
import {mapState} from "pinia";
import {useClientStore} from "../../stores/ClientStore";
import commonLists from "../../mixins/commonLists";

export default {
    name: 'ArtistDetails',
    components: {ArtistProfileMedia,},
    mixins: [ commonLists ],
    computed: {
        ...mapState(useClientStore, {
            artist: 'artistInfo',
            regions: 'regions',
        }),
        combinedCategories() {
            return this.artist.categories.map(parent => {
                const child = this.artist.subcategories.find(child => child.parent_id === parent.id);
                return child ? `${parent.name} - ${child.name}` : parent.name;
            });
        },
    },
    methods: {
        getLangName(id) {
            const langId = Number(id);

            if (langId === 33) {
                return this.artist?.other_user_languages || ''
            }

            const foundLang = this.languages.find(lang => lang.id === langId);
            return foundLang ? foundLang.name : '';
        },
        getRegionName(id) {
            const found = this.regions.find(region => region.id === Number(id))
            if (found) {
                return found.name
            }
        }
    }
}

</script>
<style>

</style>
